import { observer } from "mobx-react-lite";
import './HeaderStep.scss';

const HeaderStep = observer(({ id, index, title, right, className = '' }) => {
    return (
        <div id={id} className={`HeaderStep ${className}`}>

            {index !== undefined ? <div className="HeaderStep__num">{index + 1}</div> : null}
            <div className="HeaderStep__title">{title}</div>
            {
                right ? <div className="HeaderStep__right">{right}</div> : null
            }
        </div>
    );
});
HeaderStep.displayName = 'HeaderStep';

export default HeaderStep;